import React, { Component } from 'react';
import { Modal } from 'semantic-ui-react';
import { connect } from 'react-redux';

import ShowVideo from '../imageVideo/ShowVideo';
import { closeModal } from '../../actions/modalAction';

const actions = { closeModal };

class ShowVideoModal extends Component {
  render() {
    return (
      <Modal 
      //size="tiny" 
      open={true} 
      onClose={this.props.closeModal}
      closeOnEscape={false}
      closeOnDimmerClick={false}
      style = {{
        //background:'transparent',
        backgroundColor:'black',
        marginTop:'30px',
        padding: '0px',
      }}
      >
       
        <Modal.Content 
        style = {{
        //background:'transparent',
        backgroundColor:'black',
        margin:'0px',
        padding: '0px',
      }}
       >
        <ShowVideo 
            videoPath = {this.props.videoPath}
            />
        </Modal.Content>
      </Modal>
    );
  }
}

export default connect(
  null,
  actions
)(ShowVideoModal);
